<div class="h-full overflow-x-auto overflow-y-hidden">
    <div class="flex h-full items-start">
        <ng-container [ngTemplateOutlet]="columnTemplate()"></ng-container>
    </div>
</div>
